import React, { Component } from 'react';
import { Text, View, Animated, StyleSheet, TouchableOpacity, TouchableHighlight, Image, Dimensions } from 'react-native';
import { QLinearGradient } from 'qunar-react-native';
import { Icon } from '@qnpm/q-theme';
import { qAccessibilityLabel, performanceUtil } from '@qnpm/q-design-utils';
import { Shadow } from '@qnpm/q-shadow';
import { getIDayStyle } from '../../utils/handle';
import { DAY_SELECTED_COLORS, DAY_TOUCHABLE_OPACITY, isMiniScreen } from '../../utils/constant';
import { PADDING_HORIZONTAL, DAY_ITEM_SPACE } from '../style';
export default class Day extends Component {
    constructor() {
        super(...arguments);
        this.scaleAnimate = new Animated.Value(1);
        this.onPressDay = async (event) => {
            const { onPress } = this.props;
            onPress && onPress(event);
        };
        this.startAnimation = () => {
            const { data: { dayScale = 1 } } = this.props;
            Animated.spring(this.scaleAnimate, {
                toValue: dayScale,
                friction: 3,
                tension: 50,
                useNativeDriver: true
            }).start();
        };
        this.resetAnimation = () => {
            Animated.spring(this.scaleAnimate, {
                toValue: 1,
                friction: 3,
                tension: 40,
                useNativeDriver: true
            }).start();
        };
    }
    shouldComponentUpdate(nextProps) {
        return !performanceUtil.fastDeepEqual(this.props, nextProps);
    }
    componentDidUpdate(prevProps) {
        const { selected: prevSelected } = prevProps;
        const { selected } = this.props;
        // 选中时执行动画
        if (!prevSelected && selected) {
            this.startAnimation();
        }
    }
    render() {
        let { refreshWidth } = this.props;
        refreshWidth = refreshWidth
            ? refreshWidth
            : Dimensions.get('window').width;
        const dayWidth = (refreshWidth - PADDING_HORIZONTAL * 2 - DAY_ITEM_SPACE * 6) / 7;
        const computedStyle = getIDayStyle(this.props, dayWidth);
        return (<View style={[styles.rowContainer, computedStyle.wrapper]}>
                <View style={[
            computedStyle.fill,
            {
                position: 'absolute',
                zIndex: -1
            }
        ]}/>
                {this.renderDayView(computedStyle)}
            </View>);
    }
    /**
     * 根据选中状态渲染视图
     * @param computedStyle
     */
    renderDayView(computedStyle) {
        const { selected, disabled } = this.props;
        if (selected && !disabled) {
            return this.renderSelectedDayItem(computedStyle);
        }
        return this.renderNormalDayItem(computedStyle);
    }
    /**
     * 已选择日期
     * @param computedStyle
     */
    renderSelectedDayItem(computedStyle) {
        const { disabled, computedStyle: pComputedStyle, accessibilityPreName, data } = this.props;
        return (<TouchableHighlight style={styles.rowContainer} activeOpacity={1} onPress={this.onPressDay} underlayColor="transparent" {...qAccessibilityLabel(`${accessibilityPreName}DayItem#${data.value}`)} onHideUnderlay={this.resetAnimation} onShowUnderlay={this.startAnimation} disabled={disabled}>
                <Animated.View style={{
            transform: [
                {
                    scale: this.scaleAnimate
                }
            ]
        }}>
                    <Shadow shadow="shadow3" style={styles.shadowView}>
                        <QLinearGradient style={[
            styles.linearGradient,
            pComputedStyle.dayItem.linearGradient
        ]} colors={DAY_SELECTED_COLORS} start={{ x: 0.0, y: 0.0 }} end={{ x: 1.0, y: 1.0 }}>
                            {this.renderContent(computedStyle)}
                        </QLinearGradient>
                    </Shadow>
                </Animated.View>
            </TouchableHighlight>);
    }
    /**
     * 未选中日期
     * @param computedStyle
     */
    renderNormalDayItem(computedStyle) {
        const { disabled, accessibilityPreName, data } = this.props;
        return (<TouchableOpacity style={[styles.rowContainer]} activeOpacity={DAY_TOUCHABLE_OPACITY} onPress={this.onPressDay} {...qAccessibilityLabel(`${accessibilityPreName}DayItem#${data.value}`)} disabled={disabled}>
                {this.renderContent(computedStyle)}
            </TouchableOpacity>);
    }
    /**
     * 箭头
     * @param headerColor
     * @param isBefore
     */
    renderArrow(headerColor, isBefore) {
        const { computedStyle: pComputedStyle } = this.props;
        return (<Icon name={isBefore ? 'retTrip' : 'outTrip'} size={9} color={headerColor ? headerColor.color : '#FFFFFF'} 
        // @ts-ignore
        style={[
            styles.headerArrow,
            isBefore
                ? pComputedStyle.dayItem.headerBeforeArrow
                : pComputedStyle.dayItem.headerAfterArrow
        ]}/>);
    }
    /**
     * 渲染按钮内容
     * @param computedStyle
     */
    renderContent(computedStyle) {
        const { data, selected, computedStyle: pComputedStyle } = this.props;
        const { selectedIndex = 0 } = data;
        const { header, content = '', footer, showArrow, imageUri } = this.getRenderData();
        const canShowArrow = selected && showArrow;
        const showAfterArrow = canShowArrow && selectedIndex === 0;
        const showBeforeArrow = canShowArrow && selectedIndex > 0;
        // 如果是中文的话，使用小的字号
        const contentTextStyle = /\d+/.test(content.toString())
            ? pComputedStyle.dayItem.contentText
            : pComputedStyle.dayItem.contentSmallText;
        let { refreshWidth } = this.props;
        refreshWidth = refreshWidth
            ? refreshWidth
            : Dimensions.get('window').width;
        return (<Animated.View style={[
            styles.container,
            pComputedStyle.dayItem.container,
            computedStyle.container,
            {
                width: (refreshWidth -
                    PADDING_HORIZONTAL * 2 -
                    DAY_ITEM_SPACE * 6) /
                    7
            }
        ]}>
                {header ? (<View style={[
            styles.headerContainer,
            pComputedStyle.dayItem.headerContainer
        ]}>
                        <Text numberOfLines={1} style={[
            styles.headerText,
            pComputedStyle.dayItem.headerText,
            this.computeDescTextSize(header),
            computedStyle.header
        ]}>
                            {header || ''}
                        </Text>
                        
                        {showAfterArrow || showBeforeArrow
            ? this.renderArrow(computedStyle.header, showBeforeArrow)
            : null}
                    </View>) : null}
                <Text style={[
            styles.contentText,
            computedStyle.content,
            contentTextStyle
        ]}>
                    {content}
                </Text>
                {footer ? (<Text numberOfLines={1} style={[
            styles.footerText,
            pComputedStyle.dayItem.footerText,
            computedStyle.footer
        ]}>
                        {footer || ''}
                    </Text>) : null}
                {imageUri ? (<Image source={{ uri: imageUri }} style={[
            styles.footerImage,
            pComputedStyle.dayItem.footerImage
        ]}/>) : null}
            </Animated.View>);
    }
    /**
     * 组装渲染参数
     */
    getRenderData() {
        const { header, content, footer, data } = this.props;
        const { extra, config } = data;
        const { header: cHeader, content: cContent, footer: cFooter, imageUri } = config || {};
        const { header: eHeader, content: eContent, footer: eFooter, showArrow } = extra || {};
        return {
            header: (eHeader === null || eHeader === void 0 ? void 0 : eHeader.text) || (cHeader === null || cHeader === void 0 ? void 0 : cHeader.text) || header,
            content: (eContent === null || eContent === void 0 ? void 0 : eContent.text) || (cContent === null || cContent === void 0 ? void 0 : cContent.text) || content,
            footer: (eFooter === null || eFooter === void 0 ? void 0 : eFooter.text) || (cFooter === null || cFooter === void 0 ? void 0 : cFooter.text) || footer,
            imageUri,
            showArrow
        };
    }
    /**
     * 根据字数设置描述文字大小
     * @param text
     */
    computeDescTextSize(text) {
        if (text && text.length > 4) {
            return { fontSize: isMiniScreen ? 7 : 8 };
        }
        return { fontSize: 10 };
    }
}
const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center'
    },
    shadowView: {
        backgroundColor: 'transparent'
    },
    rowContainer: {
        flexDirection: 'row',
        backgroundColor: 'transparent',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden'
    },
    linearGradient: {
        flex: 1
    },
    headerContainer: {
        position: 'absolute',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    headerArrow: {
        position: 'absolute',
        opacity: 0.7,
        paddingTop: 0,
        justifyContent: 'center',
        alignItems: 'center',
        bottom: 0,
        top: 0
    },
    headerText: {
        top: 0
    },
    contentText: {
        fontWeight: 'bold'
    },
    footerText: {
        position: 'absolute'
    },
    footerImage: {
        position: 'absolute',
        zIndex: -3
    }
});
